// ========== Template de Contrat PDF Master Ski Pilou ==========

import jsPDF from 'jspdf';
import dayjs from 'dayjs';

export const generateMasterSkiPilouContractPDF = async (reservation) => {
  try {
    console.log('📄 Generating Master Ski Pilou Contract PDF...');
    
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;
    
    // ========== HEADER ==========
    // Logo placeholder
    doc.setFontSize(8);
    doc.setFont('helvetica', 'normal');
    doc.text('MASTER SKI PILOU', pageWidth / 2, 20, { align: 'center' });
    doc.text('ST BARTH', pageWidth / 2, 25, { align: 'center' });
    
    // Encadré du logo
    doc.rect(pageWidth / 2 - 25, 10, 50, 20);
    
    // Titre principal
    doc.setFontSize(20);
    doc.setFont('helvetica', 'bold');
    doc.text('Lunch Contract', pageWidth / 2, 50, { align: 'center' });
    
    // Date du jour
    doc.setFontSize(12);
    doc.setFont('helvetica', 'normal');
    doc.text(`On ${dayjs().format('DD/MM/YYYY')}`, 20, 70);
    
    // ========== CLIENT DETAILS ==========
    doc.setFontSize(14);
    doc.setFont('helvetica', 'bold');
    doc.text('Client Details', 20, 90);
    
    // Ligne de séparation
    doc.setLineWidth(0.5);
    doc.line(20, 95, pageWidth - 20, 95);
    
    doc.setFontSize(12);
    doc.setFont('helvetica', 'normal');
    doc.text(`Date: ${dayjs(reservation.charter_date).format('DD/MM/YYYY')}`, 20, 110);
    doc.text(`Client: ${reservation.client_name}`, 20, 125);
    
    // ========== RESERVATION DETAILS ==========
    doc.setFontSize(14);
    doc.setFont('helvetica', 'bold');
    doc.text('Reservation Details', 20, 150);
    
    // Ligne de séparation
    doc.line(20, 155, pageWidth - 20, 155);
    
    // Table header
    doc.setFillColor(230, 230, 230);
    doc.rect(20, 165, pageWidth - 40, 15, 'F');
    
    doc.setFontSize(12);
    doc.setFont('helvetica', 'bold');
    doc.text('Description', 25, 175);
    doc.text('Price', pageWidth - 40, 175);
    
    // Table content
    let yPosition = 190;
    doc.setFont('helvetica', 'normal');
    
    if (reservation.lunch_reservation_items && reservation.lunch_reservation_items.length > 0) {
      reservation.lunch_reservation_items.forEach(item => {
        // Vérifier si on a assez de place sur la page
        if (yPosition > pageHeight - 50) {
          doc.addPage();
          yPosition = 30;
        }
        
        doc.text(`${item.item_name} (${item.quantity}x)`, 25, yPosition);
        doc.text(`${item.total_price}€`, pageWidth - 40, yPosition);
        yPosition += 15;
      });
    } else {
      // Utiliser les placeholders du template original
      doc.text('Articles sélectionnés', 25, yPosition);
      doc.text(`${reservation.total_amount || 0}€`, pageWidth - 40, yPosition);
      yPosition += 15;
    }
    
    // Total line
    doc.setLineWidth(0.5);
    doc.line(pageWidth - 80, yPosition, pageWidth - 20, yPosition);
    yPosition += 10;
    
    doc.setFont('helvetica', 'bold');
    doc.text('TOTAL:', pageWidth - 80, yPosition);
    doc.text(`${reservation.total_amount || 0}€`, pageWidth - 40, yPosition);
    
    // ========== SIGNATURE ==========
    yPosition += 30;
    
    doc.setFontSize(12);
    doc.setFont('helvetica', 'bold');
    doc.text('Signature :', 20, yPosition);
    
    // Zone de signature (rectangle gris)
    doc.setFillColor(200, 200, 200);
    doc.rect(20, yPosition + 5, 80, 30, 'F');
    
    // Si signature électronique disponible
    if (reservation.lunch_signed_contracts && reservation.lunch_signed_contracts.length > 0) {
      const contract = reservation.lunch_signed_contracts[0];
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(10);
      doc.text(`Signé électroniquement le:`, 20, yPosition + 45);
      doc.text(`${dayjs(contract.signature_date).format('DD/MM/YYYY HH:mm')}`, 20, yPosition + 55);
      
      // TODO: Ajouter l'image de signature si disponible
      // if (contract.signature_data) {
      //   doc.addImage(contract.signature_data, 'PNG', 20, yPosition + 5, 80, 30);
      // }
    }
    
    // ========== PAYMENT LINK ==========
    yPosition += 70;
    
    doc.setFontSize(12);
    doc.setFont('helvetica', 'bold');
    doc.text('Payment link :', 20, yPosition);
    
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(0, 0, 255); // Bleu pour le lien
    doc.text('VoxPay Email/Web Payment', 20, yPosition + 15);
    doc.setTextColor(0, 0, 0); // Retour au noir
    
    // ========== FOOTER ==========
    const footerY = pageHeight - 40;
    
    // Ligne de séparation
    doc.setLineWidth(0.5);
    doc.line(20, footerY - 10, pageWidth - 20, footerY - 10);
    
    doc.setFontSize(10);
    doc.setFont('helvetica', 'bold');
    doc.text('MASTER SKI PILOU', pageWidth / 2, footerY, { align: 'center' });
    
    doc.setFont('helvetica', 'normal');
    doc.text('Rue Jeanne d\'Arc – GUSTAVIA - 97133 Saint-Barthélemy', pageWidth / 2, footerY + 8, { align: 'center' });
    doc.text('Tél. : 05 90 27 91 79 Fax. : 05 90 27 55 70', pageWidth / 2, footerY + 16, { align: 'center' });
    doc.text('Siret n° 48013153100018', pageWidth / 2, footerY + 24, { align: 'center' });
    
    console.log('✅ PDF Contract generated successfully');
    
    return doc;
    
  } catch (error) {
    console.error('❌ Error generating PDF contract:', error);
    throw error;
  }
};

/**
 * Télécharger le contrat PDF
 */
export const downloadContractPDF = async (reservation) => {
  try {
    const doc = await generateMasterSkiPilouContractPDF(reservation);
    const filename = `Contrat_MSP_${reservation.client_name.replace(/\s+/g, '_')}_${dayjs(reservation.charter_date).format('YYYYMMDD')}.pdf`;
    doc.save(filename);
    
    return { success: true, filename };
  } catch (error) {
    console.error('❌ Error downloading PDF:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Générer PDF en base64 pour email
 */
export const generateContractPDFBase64 = async (reservation) => {
  try {
    const doc = await generateMasterSkiPilouContractPDF(reservation);
    const pdfBase64 = doc.output('datauristring');
    
    return { 
      success: true, 
      base64: pdfBase64,
      filename: `Contrat_MSP_${reservation.client_name.replace(/\s+/g, '_')}_${dayjs(reservation.charter_date).format('YYYYMMDD')}.pdf`
    };
  } catch (error) {
    console.error('❌ Error generating PDF base64:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Preview PDF dans une nouvelle fenêtre
 */
export const previewContractPDF = async (reservation) => {
  try {
    const doc = await generateMasterSkiPilouContractPDF(reservation);
    const pdfDataUri = doc.output('datauristring');
    
    const newWindow = window.open();
    newWindow.document.write(`
      <iframe 
        src="${pdfDataUri}" 
        width="100%" 
        height="100%" 
        style="border: none;"
      ></iframe>
    `);
    
    return { success: true };
  } catch (error) {
    console.error('❌ Error previewing PDF:', error);
    return { success: false, error: error.message };
  }
};